Ext.define('SA.model.createimport.Model', {
    getColumnDefinitionList() {
        return this.columnDefinitionList;
    },

    getCountryCode() {
        return this.countryCode;
    },

    getDatasetName() {
        return this.datasetName;
    },

    getHeaderNames() {
        return this.getTupleList().getHeaderNames();
    },

    getTupleList() {
        return this.tupleList;
    },

    serializeForRequest() {
        var dataset = this.getDatasetName(),
            country = this.getCountryCode(),
            files = this.getTupleList().serializeForRequest(),
            columns = this.columnDefinitionList.serializeForRequest();

        return {dataset, country, files, columns};
    },

    serializeForReview() {
        var datasetName = this.getDatasetName(),
            tuples = this.getTupleList().serializeForReview(),
            columns = this.columnDefinitionList.serializeForReview();

        return {datasetName, tuples, columns};
    },

    setColumnDefinitions(columnDefinitions) {
        this.columnDefinitionList = new SA.model.createimport.ColumnDefinitionList(columnDefinitions);

        this.tupleList.setColumnDefinitions(columnDefinitions);
    },

    setCountryCode(countryCode) {
        this.countryCode = countryCode;
    },

    setDatasetName(datasetName) {
        this.datasetName = datasetName;
    },

    setTuples(tuples) {
        this.tupleList = new SA.model.createimport.FileTupleList(tuples);
    }
});